<template>
	<div id="q-app">
		<router-view />

		<activity-downloader />
	</div>
</template>

<script>
import ActivityDownloader from './components/utils/ActivityDownloader'
import { mapGetters } from 'vuex'
import { createMetaMixin } from 'quasar'
import { Platform } from 'quasar'
import { AppUpdate } from '@capawesome/capacitor-app-update'
import * as Sentry from '@sentry/vue'

const metaData = {
	title: process.env.PROJECT_NAME ?? 'Etraining',
	// optional; sets final title as "Index Page - My Website", useful for multiple level meta
	titleTemplate: (title) => `${process.env.PROJECT_NAME} | ${title}`,

	// meta tags
	meta: {
		description: { name: 'description', content: 'Powered by Take 5' },
		keywords: {
			name: 'keywords',
			content: 'Etraining, e-learning, learning, training, courses, LMS, education, business',
		},
		equiv: { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' },
	},
}

export default {
	name: 'App',

	computed: {
		...mapGetters({
			offline_activities: 'offline_course/activities',
		}),
	},

	components: {
		'activity-downloader': ActivityDownloader,
	},

	mixins: [createMetaMixin(metaData)],

	methods: {
		async checkStoreForUpdates() {
			if (!Platform.is.capacitor) return

			try {
				// 1. Consulta a loja (Play Store ou App Store)
				const result = await AppUpdate.getAppUpdateInfo()

				// O result.updateAvailability retorna um código numérico. 
				// O número 2 significa que UPDATE_AVAILABLE (Atualização Disponível)
				if (result.updateAvailability === 2) {
					
					if (this.$q.platform.is.android) {
						// No ANDROID: Você pode usar a tela nativa do próprio Google bloqueando o app
						// O método performImmediateUpdate() levanta uma tela do Google exigindo a atualização.
						await AppUpdate.performImmediateUpdate()
					} 
					else if (this.$q.platform.is.ios) {
						// No IOS: A Apple não tem uma tela nativa de bloqueio igual a do Google.
						// Neste caso, você pode chamar o método openAppStore() ou usar um modal seu (do Quasar) 
						// para avisar o usuário e depois rodar o openAppStore().
						
						// Exemplo simples abrindo direto a loja:
						await AppUpdate.openAppStore()
					
						// *Dica: Se quiser BLOQUEAR o usuário no iOS, você deve ativar aquele 
						// <q-dialog persistent> que criamos no exemplo anterior e no clique do botão 
						// chamar AppUpdate.openAppStore().
					}
				}
			} catch (error) {
				console.error('Falha ao verificar atualizações nas lojas:', error)
				
				// Captura o erro no Sentry
				Sentry.captureException(error, {
					tags: { contexto: 'verificacao_versao_lojas_nativas' }
				});
			}
		}
	},

	created() {
		if (this.$q.platform.is.capacitor) {
			this.checkStoreForUpdates()
			let offline_activities_copy = Object.assign([], this.offline_activities)
			if (offline_activities_copy) {
				offline_activities_copy.forEach((activity, index) => {
					if (activity.downloading) offline_activities_copy.splice(index, 1)
				})
			}
			this.$store.dispatch('offline_course/SET_ACTIVITIES', [offline_activities_copy])
		}
	},
}
</script>
